<script setup lang="ts">
import { getMenu } from '@/core/useMenu'
import { useI18n } from 'vue-i18n'
import AppMenuItem from './AppMenuItem.vue'
import { useLayout } from './composables/layout'

const { t } = useI18n()

const model = getMenu(t)
const { toggleMenu, layoutState } = useLayout()

const item = {
  label: t('sidebar.title')
}
</script>

<template>
  <ul class="layout-menu">
    <div :class="layoutState.staticMenuDesktopInactive ? 'flex justify-content-end pt-2 pr-4' : 'flex justify-content-between'">
      <app-menu-item v-if="!layoutState.staticMenuDesktopInactive || layoutState.staticMenuMobileActive" :item="item" :index="0"></app-menu-item>
      <Button
        class="layout-menu-button layout-topbar-action button-rect"
        @click="toggleMenu"
        v-tooltip.right="t('navbar.toggleMenu')"
        variant="text"
        :icon="!layoutState.staticMenuDesktopInactive ? 'pi pi-arrow-circle-left' : 'pi pi-arrow-circle-right'"
      >
      </Button>
    </div>
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i + 1"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="css" scoped>
.button-rect {
  margin-left: 0.5rem !important;
  width: 4rem !important;
}
</style>
